import { iThumbdoc } from './interfaces'
import { SITE_CLIENT } from '../types'
const setImage = (key: string, file: string) => {
  return `./image/${key}/${file}`
}
export default class ObjPortfolio {
  clients: { [index: string]: Client } = {}
  constructor() {
    this.clients = {}
  }

  addClient(
    key: string,
    client: string,
    linkText: string, // the text used when this client's link appears in the sidebar
    description: string, // In the gallery, each slide will have this as its title.
    technologies: string,
    timeframe: string,
    image: string,
    width: string,
    height: string,
    lastKey: string,
    nextKey: string
  ) {
    this.clients[key] = new Client(
      key,
      client,
      linkText,
      description,
      technologies,
      timeframe,
      image,
      width,
      height,
      lastKey,
      nextKey
    )
    return this.clients[key]
  }

  // Not migrated from the php file:  getClient(), getIcon(), getAlt()
  // Needed but not yet migrated from php file:  loadData()
  loadData() {
    let client = this.addClient(
      SITE_CLIENT.zillow,
      'Zillow',
      'Zillow Home Mortgages',
      '',
      '',
      '',
      setImage(SITE_CLIENT.zillow, 'homepage_500x290.png'),
      '500',
      '290',
      SITE_CLIENT.firstAm,
      SITE_CLIENT.spectrum
    )

    client.addThumbdoc(
      setImage(SITE_CLIENT.zillow, 'homepage_500x290.png'),
      setImage(SITE_CLIENT.zillow, 'homepageThumb.png'),
      'Zillow: ZillowHomeLoans.com home page',
      500,
      290
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.zillow, 'agentPageStatusTracker.png'),
      setImage(SITE_CLIENT.zillow, 'agentPageStatusTrackerThumb.png'),
      'Zillow Agent Landing Page with Status Tracker showing the progress of a client loan.',
      800,
      475
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.zillow, 'loanOfficer.png'),
      setImage(SITE_CLIENT.zillow, 'loanOfficerThumb.png'),
      'Zillow Mortgage Application Center: Contact page for a Loan Officer (mobile display)',
      446,
      800
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.zillow, 'tellUsAboutFinances.png'),
      setImage(SITE_CLIENT.zillow, 'tellUsAboutFinancesThumb.png'),
      'Zillow Mortgage Application Center: Financial questionaire for applying for a loan (mobile display).',
      397,
      800
    )

    client = this.addClient(
      SITE_CLIENT.firstAm,
      'First American',
      'First American Title Insurance',
      '',
      '',
      '',
      setImage(SITE_CLIENT.firstAm, 'splash550x139.png'),
      '550',
      '139',
      SITE_CLIENT.fashionnova,
      SITE_CLIENT.spectrum
    )

    client.addThumbdoc(
      setImage(SITE_CLIENT.firstAm, 'amendmentsModifications1000x516.png'),
      setImage(SITE_CLIENT.firstAm, 'amendmentsModificationsThumb.png'),
      'First American Bank Sequoia app: page for adding modifications to an existing title insurance document.',
      1000,
      516
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.firstAm, 'caseNotes800x504.png'),
      setImage(SITE_CLIENT.firstAm, 'caseNotesThumb.png'),
      'First American Bank Sequoia app: Vesting Chain showing title insurance history and Case Notes showing validity of the chain.',
      800,
      504
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.firstAm, 'vestingChain1000x572.png'),
      setImage(SITE_CLIENT.firstAm, 'vestingChainThumb.png'),
      '',
      1000,
      572
    )

    client = this.addClient(
      SITE_CLIENT.fashionnova,
      'FashionNova.com',
      'Fashion Nova',
      '',
      '',
      '',
      setImage(SITE_CLIENT.fashionnova, 'splash500x334.png'),
      '500',
      '334',
      SITE_CLIENT.crocs,
      SITE_CLIENT.firstAm
    )

    client.addThumbdoc(
      setImage(SITE_CLIENT.fashionnova, 'fn-buyerActions500x450.png'),
      setImage(SITE_CLIENT.fashionnova, 'fn-buyerActionsThumb.png'),
      'FashionNova: Purchase Order actions',
      500,
      450
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.fashionnova, 'fn-buyerColorWorksheet700x468.png'),
      setImage(SITE_CLIENT.fashionnova, 'fn-buyerColorWorksheetThumb.png'),
      'FashionNova: Purchase Order color details',
      700,
      468
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.fashionnova, 'netsuitePO700x284.png'),
      setImage(SITE_CLIENT.fashionnova, 'netsuitePOThumb.png'),
      'FashionNova: Purchase Order in Netsuite',
      700,
      284
    )

    client = this.addClient(
      SITE_CLIENT.crocs,
      'Crocs.com',
      'Crocs',
      '',
      '',
      '',
      setImage(SITE_CLIENT.crocs, 'splash500x290.png'),
      '500',
      '290',
      SITE_CLIENT.tenx,
      SITE_CLIENT.fashionnova
    )

    client.addThumbdoc(
      'https://youtu.be/ygAPkMdHumU',
      './image/crocs/CQATdemoPart1thumb.png',
      'Crocs.com Automated UI Testing Platform (part 1)',
      500,
      290
    )
    client.addThumbdoc(
      'https://youtu.be/aDSRDaO40oM',
      './image/crocs/CQATdemoPart2thumb.png',
      'Crocs.com Automated UI Testing Platform (part 2)',
      500,
      290
    )

    client = this.addClient(
      SITE_CLIENT.tenx,
      'Ten-X/Auction.com',
      'Ten-X',
      '',
      '',
      '',
      setImage(SITE_CLIENT.tenx, 'splash500x290.png'),
      '500',
      '290',
      SITE_CLIENT.crocs,
      SITE_CLIENT.sears
    )

    client.addThumbdoc(
      setImage(SITE_CLIENT.tenx, 'splash500x290.png'),
      setImage(SITE_CLIENT.tenx, 'splashThumb.png'),
      'Auction.com: homepage with search.',
      500,
      290
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.tenx, 'searchFilterOptions_500x269.png'),
      setImage(SITE_CLIENT.tenx, 'searchFilterOptionsThumb.png'),
      'Auction.com: search filter options.',
      500,
      269
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.tenx, 'SRPtop_500x408.png'),
      setImage(SITE_CLIENT.tenx, 'SRPtopThumb.png'),
      'Auction.com: search results (list view).',
      500,
      408
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.tenx, 'SRPmapView_500x497.png'),
      setImage(SITE_CLIENT.tenx, 'SRPmapViewThumb.png'),
      'Auction.com: search results (map view).',
      500,
      497
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.tenx, 'PDPafterRegistered_500x370.png'),
      setImage(SITE_CLIENT.tenx, 'PDPafterRegisteredThumb.png'),
      'Auction.com: Property Display page with active auction.',
      500,
      370
    )
    client.addThumbdoc(
      'https://youtu.be/bTJhUGtZad0',
      setImage(SITE_CLIENT.tenx, 'seleniumTestsThumb.png'),
      'Auction.com Selenium Tests (video)',
      600,
      400
    )

    client = this.addClient(
      SITE_CLIENT.sears,
      'Sears',
      'Sears',
      '',
      '',
      '',
      setImage(SITE_CLIENT.sears, 'splash500x468.png'),
      '500',
      '468',
      SITE_CLIENT.tenx,
      SITE_CLIENT.pathfinder
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.sears, 'homepage.png'),
      setImage(SITE_CLIENT.sears, 'homepageSearsThumb.png'),
      'Sears: mobile web home page.',
      322,
      571
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.sears, 'rewards.png'),
      setImage(SITE_CLIENT.sears, 'rewardsThumb.png'),
      'Sears:  Rewards page.',
      320,
      565
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.sears, 'loadUp.png'),
      setImage(SITE_CLIENT.sears, 'loadUpThumb.png'),
      'Sears:  Currently linked cards.',
      321,
      545
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.sears, 'enteringCard.png'),
      setImage(SITE_CLIENT.sears, 'enteringCardThumb.png'),
      'Sears:  entering a new card to be linked.',
      321,
      571
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.sears, 'cardAdded.png'),
      setImage(SITE_CLIENT.sears, 'cardAddedThumb.png'),
      'Sears:  card successfully linked.',
      321,
      568
    )

    client = this.addClient(
      SITE_CLIENT.pathfinder,
      'Pathfinder Software',
      'Pathfinder',
      '',
      '',
      '',
      setImage(SITE_CLIENT.pathfinder, 'splash500x468.png'),
      '500',
      '468',
      SITE_CLIENT.sears,
      SITE_CLIENT.truven
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.pathfinder, 'login.png'),
      setImage(SITE_CLIENT.pathfinder, 'loginThumb.png'),
      'AACN Bedside',
      362,
      711
    )
    // client.addThumbdoc('./image/path/splash500x468.png', './image/path/splashThumb.png',
    //   'AACN Bedside', 500, 468)
    client.addThumbdoc(
      setImage(SITE_CLIENT.pathfinder, 'dysrhythmiaMonitoring.png'),
      setImage(SITE_CLIENT.pathfinder, 'dysrhythmiaMonitoring_thumb.png'),
      'AACN Bedside',
      363,
      709
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.pathfinder, 'dysrhytmias.png'),
      setImage(SITE_CLIENT.pathfinder, 'dysrhytmiasThumb.png'),
      'AACN Bedside',
      362,
      709
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.pathfinder, 'continuCare_home_784x721.png'),
      setImage(SITE_CLIENT.pathfinder, 'continuCare_home_thumb.png'),
      'Kimberly-Clark ContinuCare: Dashboard',
      784,
      721
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.pathfinder, 'continuCare_medications_785x721.png'),
      setImage(SITE_CLIENT.pathfinder, 'continuCare_medications_thumb.png'),
      'Kimberly-Clark ContinuCare: Medications',
      785,
      721
    )
    client.addThumbdoc(
      'https://youtu.be/GFjvrAIEmCs',
      setImage(SITE_CLIENT.pathfinder, 'metroPulseThumb.png'),
      'MetroPulse Research Tool on City Demographics (video demo)',
      600,
      400
    )

    // Note the different value for url!
    client = this.addClient(
      SITE_CLIENT.truven,
      'Truven Health Analytics',
      'Truven',
      '',
      '',
      '',
      setImage(SITE_CLIENT.truven, 'splash500x428.png'),
      '500',
      '428',
      SITE_CLIENT.pathfinder,
      SITE_CLIENT.ubs
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.truven, 'homepage922x789.png'),
      setImage(SITE_CLIENT.truven, 'homepage_thumb.png'),
      'HIE Advantage Analytics: Population Health Dashboard.',
      922,
      789
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.truven, 'diabetesSummary.png'),
      setImage(SITE_CLIENT.truven, 'diabetesSummaryThumb.png'),
      'HIE Advantage Analytics: Diabetes Summary.',
      926,
      1044
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.truven, 'populations.png'),
      setImage(SITE_CLIENT.truven, 'populationsThumb.png'),
      'HIE Advantage Analytics: Populations.',
      921,
      769
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.truven, 'populationSummary.png'),
      setImage(SITE_CLIENT.truven, 'populationSummaryThumb.png'),
      'HIE Advantage Analytics: Population Wizard.',
      1030,
      768
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.truven, 'dischargeTimeframe.png'),
      setImage(SITE_CLIENT.truven, 'dischargeTimeframeThumb.png'),
      'HIE Advantage Analytics: Discharge Timeframe.',
      926,
      758
    )

    client = this.addClient(
      SITE_CLIENT.ubs,
      'UBS Investment Bank/Equities',
      'UBS',
      '',
      '',
      '',
      setImage(SITE_CLIENT.ubs, 'splash500x406.gif'),
      '500',
      '406',
      SITE_CLIENT.pathfinder,
      SITE_CLIENT.usaf
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.ubs, 'liquiditySnapshot.gif'),
      setImage(SITE_CLIENT.ubs, 'liquiditySnapshotThumb.gif'),
      'A daily report in PDF format, assembled using iText and jFreeChart, and emailed nightly.',
      900,
      698
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.ubs, 'monitron.gif'),
      setImage(SITE_CLIENT.ubs, 'monitronThumb.gif'),
      'Monitron, a control panel for standalone Java applications running externally from Pinpoint Web.',
      994,
      734
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.ubs, 'manageGuiPluginPermissions.gif'),
      setImage(SITE_CLIENT.ubs, 'manageGuiPluginPermissionsThumb.gif'),
      'GUI plugin permissions:  a dashboard for managing Pinpoint features and functionality.',
      954,
      646
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.ubs, 'activityQuery.gif'),
      setImage(SITE_CLIENT.ubs, 'activityQueryThumb.gif'),
      'Activity Query:  a report tool on the audit trail of all user-initiated activities in Pinpoint.',
      938,
      763
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.ubs, 'QuattroIoi.gif'),
      setImage(SITE_CLIENT.ubs, 'QuattroIoiThumb.gif'),
      'Quattro Tool: reports on Indications of Interest (trading activity).',
      1012,
      794
    )

    client = this.addClient(
      SITE_CLIENT.usaf,
      'US Air Force/Lockheed Martin',
      'US Air Force',
      'Air Force Portal and Data Services',
      'Websphere, Tomcat, JSP, JSTL, Broadvision, Autonomy, Tivoli, Akamai',
      'July 06 to Jan 07',
      setImage(SITE_CLIENT.usaf, 'splash500x290.jpg'),
      '500',
      '290',
      SITE_CLIENT.ubs,
      SITE_CLIENT.amex
    )

    client.addThumbdoc(
      setImage(SITE_CLIENT.usaf, 'homepage897x806.gif'),
      setImage(SITE_CLIENT.usaf, 'homepageThumb.gif'),
      'The Air Force Portal Login Page',
      897,
      806
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.usaf, 'AFPortal02of04.gif'),
      setImage(SITE_CLIENT.usaf, 'AFPortal02of04Thumb.gif'),
      'The Air Force Portal Home Page',
      896,
      759
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.usaf, 'AFPortal03of04.gif'),
      setImage(SITE_CLIENT.usaf, 'AFPortal03of04Thumb.gif'),
      'A search results screen from the Air Force Portal',
      897,
      806
    )

    client = this.addClient(
      SITE_CLIENT.abnAmro,
      'ABN-AMRO',
      'ABN-AMRO',
      'Workflow Application for International Letters of Credit (ABN-AMRO)',
      'J2EE, Servlets, Web Services, EJB',
      'Worked on this from May 05 to Jan 06',
      setImage(SITE_CLIENT.abnAmro, 'splash500x363.gif'),
      '500',
      '343',
      SITE_CLIENT.amex,
      SITE_CLIENT.ies
    )

    client.addThumbdoc(
      setImage(SITE_CLIENT.abnAmro, 'abnAmroImport03of11.gif'),
      setImage(SITE_CLIENT.abnAmro, 'abnAmroImport03of11Thumb.gif'),
      'The ABN-AMRO/MaxTrad International Letters of Credit workflow app:  the make letter screen',
      1280,
      1000
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.abnAmro, 'abnAmroImport04of11.gif'),
      setImage(SITE_CLIENT.abnAmro, 'abnAmroImport04of11Thumb.gif'),
      'The ABN-AMRO/MaxTrad International Letters of Credit workflow app:  the errors tab',
      1280,
      1024
    )
    client.addThumbdoc(
      './image/abnAmro/abnAmroImport05of11.gif',
      './image/abnAmro/abnAmroImport05of11Thumb.gif',
      'The ABN-AMRO/MaxTrad International Letters of Credit workflow app:  a tab showing errors',
      1280,
      1000
    )

    client = this.addClient(
      SITE_CLIENT.ies,
      'IES Abroad',
      'IES Abroad',
      'Company website for IES Abroad (Institute for the International Education of Students)',
      'Java Servlets, Struts, Tomcat, Apache, Oracle, mysql, JSP, JSP tags, Tiles, DHTML, CSS, XML, XSL',
      'Work began August 2003; site launched September 2004',
      setImage(SITE_CLIENT.ies, 'splash500x373.gif'),
      '500',
      '373',
      SITE_CLIENT.abnAmro,
      SITE_CLIENT.xb
    )

    client.addThumbdoc(
      setImage(SITE_CLIENT.ies, 'splash500x373.gif'),
      setImage(SITE_CLIENT.ies, 'splashThumb.png'),
      'The IES Abroad Homepage',
      500,
      373
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.ies, 'IESonlineApp.gif'),
      setImage(SITE_CLIENT.ies, 'IESonlineAppthumb.gif'),
      'The IES Abroad Online Application, a 7-step Wizard application',
      800,
      600
    )

    client = this.addClient(
      SITE_CLIENT.xb,
      'Expand Beyond',
      'Expand Beyond',
      'Company website redesign for Expand Beyond, maker of wireless handheld applications',
      'PHP, mysql, Apache, MS-SQL Server',
      'Began &#38; launched in 2002',
      setImage(SITE_CLIENT.xb, 'splash500x356.gif'),
      '500',
      '356',
      SITE_CLIENT.ies,
      SITE_CLIENT.maytag
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.xb, 'xbHome500x617.gif'),
      setImage(SITE_CLIENT.xb, 'xbThumb.png'),
      'Home Page',
      500,
      617
    )

    client = this.addClient(
      SITE_CLIENT.maytag,
      'Maytag Corp.',
      'Maytag Corp.',
      'Complete site redesign of Maytag Corp. Public Website using Broadvision)',
      'Broadvision, Javascript Server Pages',
      'Began and launched in 2000',
      setImage(SITE_CLIENT.maytag, 'splash500x376.gif'),
      '500',
      '376',
      SITE_CLIENT.xb,
      SITE_CLIENT.watts
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.maytag, 'splash500x376.gif'),
      setImage(SITE_CLIENT.maytag, 'splashThumb.gif'),
      'Company Home Page',
      500,
      376
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.maytag, 'maytagMyApplicances.gif'),
      setImage(SITE_CLIENT.maytag, 'maytagMyApplicancesThumb.gif'),
      '\'My Appliances\':  a list of Maytag appliances owned by the customer',
      697,
      800
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.maytag, 'myMaytagSignIn.gif'),
      setImage(SITE_CLIENT.maytag, 'myMaytagSignInThumb.gif'),
      'Sign-in Page for the Site',
      793,
      614
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.maytag, 'registerProduct.gif'),
      setImage(SITE_CLIENT.maytag, 'registerProductThumb.gif'),
      'Register a Product: add an appliance to your My Appliances page',
      826,
      820
    )

    client = this.addClient(
      SITE_CLIENT.watts,
      'Edwin Watts Golf Stores',
      'Edwin Watts',
      'E-commerce site for Edwin Watts golf shops',
      'ASP, IIS, MS_Access',
      'Began 1998, launched in 1999',
      setImage(SITE_CLIENT.watts, 'splash500x475.gif'),
      '500',
      '475',
      SITE_CLIENT.maytag,
      SITE_CLIENT.billwhitney
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.watts, 'homepage838x989.gif'),
      setImage(SITE_CLIENT.watts, 'splashThumb.jpg'),
      'Homepage for the Edwin Watts Golf e-commerce site',
      838,
      989
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.watts, 'wattsProductPage.gif'),
      setImage(SITE_CLIENT.watts, 'wattsProductPageThumb.gif'),
      'Product Page for the Edwin Watts Golf e-commerce site',
      806,
      842
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.watts, 'wattsShoppingCart.gif'),
      setImage(SITE_CLIENT.watts, 'wattsShoppingCartThumb.gif'),
      'Shopping Cart for the Edwin Watts Golf e-commerce site',
      810,
      840
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.watts, 'wattsCheckout1.gif'),
      setImage(SITE_CLIENT.watts, 'wattsCheckout1Thumb.gif'),
      'Cart Checkout part 1 for the Edwin Watts Golf e-commerce site',
      806,
      844
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.watts, 'wattsCheckout2.gif'),
      setImage(SITE_CLIENT.watts, 'wattsCheckout2Thumb.gif'),
      'Cart Checkout part 2 for the Edwin Watts Golf e-commerce site',
      808,
      846
    )

    client = this.addClient(
      SITE_CLIENT.billwhitney,
      'Bill Whitney',
      'Bill Whitney',
      'Online portfolio for digital media artist Bill Whitney',
      'DHTML, Javascript, W3C DOM',
      'Began &#38; launched in 1997',
      setImage(SITE_CLIENT.billwhitney, 'splash500x343.gif'),
      '500',
      '343',
      SITE_CLIENT.billwhitney,
      SITE_CLIENT.spectrum
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.billwhitney, 'splash500x343.gif'),
      setImage(SITE_CLIENT.billwhitney, 'splashThumb.jpg'),
      'Homepage for the Bill Whitney\'s portfolio page',
      500,
      343
    )

    client = this.addClient(
      SITE_CLIENT.spectrum,
      'Loyola University',
      'Loyola University',
      'Interactive demonstration of Musical Acoustics',
      'Java 1.1 Applet',
      'Began &#38; launched in 1996',
      setImage(SITE_CLIENT.spectrum, 'splash500x294.gif'),
      '500',
      '294',
      SITE_CLIENT.spectrum,
      SITE_CLIENT.tenx
    )
    client.addThumbdoc(
      setImage(SITE_CLIENT.spectrum, 'splash500x294.gif'),
      setImage(SITE_CLIENT.spectrum, 'splashThumb.gif'),
      'Spectrum and Waveform analysis Java applet',
      500,
      294
    )
  }
}
class Client {
  key: string
  client: string
  url: string
  linkText: string
  description: string
  technologies: string
  timeframe: string
  image: string // TODO Change to splashImage
  width: string
  height: string
  lastKey: string
  nextKey: string
  thumbdocs: Array<iThumbdoc> // ThumbDocs are the thumb images for the projects slideshow
  constructor(
    key: string,
    client: string,
    linkText: string,
    description: string,
    technologies: string,
    timeframe: string,
    image: string,
    width: string,
    height: string,
    lastKey: string,
    nextKey: string
  ) {
    this.client = client
    this.key = key
    this.linkText = linkText
    this.description = description
    this.technologies = technologies
    this.timeframe = timeframe
    this.image = image
    this.width = width
    this.height = height
    this.lastKey = lastKey
    this.nextKey = nextKey
    this.thumbdocs = []
    // this.documents = {} dead code
  }

  // Note:  html5lightbox under React only know how to retrieve the gallery version of the image
  // (i.e. the one with the "image" arg below, not the thumbImg) from the /public folder.  It cannot
  // find them from the component's folder.  But the 'thumbImage' CAN refer to an image in the
  // component, and the path should be relative to the component.
  // ThumbDocs are the thumb images for the projects slideshow
  addThumbdoc(
    image: string,
    thumbImage: string,
    description: string,
    width = 600,
    height = 400
  ): void {
    const thumbdoc = new Thumbdoc(image, thumbImage, description, width, height)
    this.thumbdocs.push(thumbdoc)
  }
}
class Thumbdoc {
  // ThumbDocs are the thumb images for the projects slideshow
  image: string
  thumbImage: string
  description: string
  width: number
  height: number
  constructor(
    image: string,
    thumbImage: string,
    description: string,
    width: number,
    height: number
  ) {
    this.image = image
    this.thumbImage = thumbImage
    this.description = description
    this.width = width
    this.height = height
  }
}
